import React from 'react';
import { Check, Headphones, FileText } from 'lucide-react';
import { Section } from './Shared';
export const MethodOverview = () => {
  const tomos = [{
    color: 'bg-[#FFF5F5] border-brand-pink/30',
    icon: '📘',
    title: 'TOMO 1 — EL DESPERTAR Y LA LIMPIEZA (Días 1 al 60)',
    subtitle: 'Limpiás lo que aleja el dinero antes de intentar atraerlo.',
    bullets: ['Disolvés tus contratos de pobreza heredados', 'Detectás tus fugas energéticas y financieras', 'Aplicás EFT Financiero para liberar el miedo', 'Activás el Protocolo de Limpieza de 7 pasos', 'Usás la Guía de Emergencia en momentos de crisis'],
    materials: 'Agenda 60 días · Mapa de deudas · 60 decretos · Planillas · Protocolo Anti-Devaluación Mental'
  }, {
    color: 'bg-[#F8FAF9] border-brand-green/20',
    icon: '📗',
    title: 'TOMO 2 — EL IMÁN Y LA INGENIERÍA (Días 61 al 120)',
    subtitle: 'Activás la atracción y construís tu sistema financiero real.',
    bullets: ['Visualización de alta frecuencia que reprograma el cerebro', 'Abrís tus 3 primeros canales de ingreso', 'Presupuesto Avanzado de 5 pilares', 'Sistema de los 3 Sobres para ahorrar desde cero', 'Plan Bola de Nieve para salir de deudas paso a paso', 'Calculás tu Número de Libertad Financiera'],
    materials: 'Agenda 60 días · Mapa de canales · Tracker de ingresos · Plan 90 días · 60 decretos'
  }, {
    color: 'bg-[#FFF9F2] border-brand-gold/20',
    icon: '📙',
    title: 'TOMO 3 — LA EXPANSIÓN Y EL SELLO (Días 121 al 180)',
    subtitle: 'Expandís lo que construiste y sellás tu nueva identidad.',
    bullets: ['Identificás tu talento monetizable y cómo escalarlo', 'Blindaje Anual contra recaídas vibracionales', 'Contrato de Abundancia Definitivo', 'Declaración de Independencia Financiera', 'Plan financiero para los próximos 12 meses', 'Comparativo Día 1 vs Día 180'],
    materials: 'Agenda 60 días · Plan 12 meses · Certificado final · Kit de Emergencia Vibracional · 60 decretos'
  }];
  const checklist = ['Actividades diarias de menos de 10 minutos', 'Decretos y planillas listos para usar', 'Protocolos de emergencia para crisis financieras', '100% adaptado a la realidad económica argentina'];
  return <Section id="method" data-id="element-168">
      <div className="text-center mb-16" data-id="element-169">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-gold/30 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-170">
          <span className="text-xl" data-id="element-171">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-gold text-sm md:text-base" data-id="element-172">
            MEGAPACK CÓDIGO DE ABUNDANCIA™
          </span>
        </div>
        <h2 className="md:text-5xl font-serif font-bold mb-4 text-[28px]" data-id="element-173">
          3 Tomos + 2 Bonus · 180 días · 10 minutos por día
        </h2>
        <p className="text-brand-muted mb-2 text-[16px]" data-id="element-174">
          Resultados visibles: 30 días. Transformación completa: 180 días.
          Herramientas: para siempre.
        </p>
      </div>

      <h3 className="font-serif font-bold text-center gold-gradient-text text-[22px] mt-[10px] mb-[10px] ml-[10px] mr-[10px]" data-id="element-175">
        LOS 3 TOMOS
      </h3>

      <div className="space-y-6 mb-16 max-w-4xl mx-auto" data-id="element-176">
        {tomos.map((tomo, i) => <div key={i} className={`${`rounded-2xl p-6 md:p-8 border ${tomo.color} backdrop-blur-sm bg-white/60 shadow-sm`} pt-[15px] pb-[15px] pl-[15px] pr-[15px]`} data-id="element-177">
            <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-178">
              <div className="text-4xl shrink-0" data-id="element-179">{tomo.icon}</div>
              <div className="flex-grow" data-id="element-180">
                <h4 className="font-serif font-bold mb-2 text-lg text-brand-gold" data-id="element-181">
                  {tomo.title}
                </h4>
                <p className="text-brand-text/90 font-medium mb-4 text-base" data-id="element-182">
                  {tomo.subtitle}
                </p>
                <ul className="space-y-2 mb-4" data-id="element-183">
                  {tomo.bullets.map((bullet, j) => <li key={j} className="flex items-start text-brand-text/80 text-[12px]" data-id="element-184">
                      <span className="text-brand-gold mr-2 mt-0.5" data-id="element-185">→</span>
                      {bullet}
                    </li>)}
                </ul>
                <div className="bg-white/50 p-3 rounded-lg border border-brand-pink/20 text-xs text-brand-text/70 flex items-center" data-id="element-186">
                  <span className="mr-2" data-id="element-187">📎</span> {tomo.materials}
                </div>
              </div>
            </div>
          </div>)}
      </div>

      <div className="glass-panel rounded-3xl p-8 md:p-12 max-w-3xl mx-auto pt-[30px] pb-[30px] pl-[30px] pr-[30px] mb-[90px] bg-white/80 border-brand-pink/30" data-id="element-188">
        <h4 className="text-xl font-serif font-bold mb-6 text-center" data-id="element-189">
          Todos los tomos incluyen:
        </h4>
        <ul className="space-y-4" data-id="element-190">
          {checklist.map((item, i) => <li key={i} className="flex items-start" data-id="element-191">
              <Check className="w-5 h-5 text-brand-green mr-3 mt-0.5 shrink-0" data-id="element-192" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-193">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center mb-12" data-id="element-194">
        <h3 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-195">
          🎁 2 BONUS INCLUIDOS
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-196">
        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden bg-white/80" data-id="element-197">
          <div className="absolute top-0 right-0 bg-brand-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-198">
            GRATIS
          </div>
          <Headphones className="w-8 h-8 text-brand-gold mb-3" data-id="element-199" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-200">
            BONUS 1 — Meditación de Activación
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-2" data-id="element-201">
            Audio MP3 · 15 minutos
          </p>
          <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-202">
            Meditación guiada para limpiar tus pensamientos financieros y
            activar tu frecuencia de abundancia antes de empezar. Usala al
            iniciar cada tomo o cuando tu frecuencia baje.
          </p>
          <div className="text-sm mt-auto" data-id="element-203">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-204">
              Valor real: $7.000 ARS
            </span>
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden bg-white/80" data-id="element-205">
          <div className="absolute top-0 right-0 bg-brand-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-206">
            GRATIS
          </div>
          <FileText className="w-8 h-8 text-brand-gold mb-3" data-id="element-207" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-208">
            BONUS 2 — Script Energético de Ventas
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-2" data-id="element-209">
            Guía PDF práctica
          </p>
          <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-210">
            Scripts listos para vender en Instagram sin culpa, vergüenza ni
            miedo al rechazo. Para activar un ingreso extra desde lo que ya
            sabés hacer.
          </p>
          <div className="text-sm mt-auto" data-id="element-211">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-212">
              Valor real: $5.000 ARS
            </span>
          </div>
        </div>
      </div>

      <div className="text-center mt-8" data-id="element-213">
        <p className="font-medium bg-brand-surfaceLight/50 inline-block px-6 py-3 rounded-full border border-brand-gold/20 text-[14px]" data-id="element-214">
          Valor total bonos:{' '}
          <span className="line-through text-brand-text/50 mx-1" data-id="element-215">
            $12.000 ARS
          </span>{' '}
          <span className="text-brand-gold font-bold" data-id="element-216">→ GRATIS</span>
        </p>
      </div>
    </Section>;
};